
export interface SetMinimizeWindowAction
{
    type: "SET_MINIMIZE_WINDOW";
    payload: {
        value: boolean;
        stateLocation: string;
    };
}

export function setMinimize(isMinimized: boolean, stateLocation: string): SetMinimizeWindowAction
{
    return {
        type: "SET_MINIMIZE_WINDOW",
        payload: {
            value: isMinimized,
            stateLocation,
        },
    };
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-minimize/src/actions/actions.ts